const DATE_COLUMNS = new Set([
  'date_of_birth', 'enrollment_date', 'discharge_date', 'iep_start', 'iep_end', 'iep_received',
]);

export function classNumRank(value) {
  const text = String(value ?? '').trim();
  if (/^-?\d+$/.test(text)) return [0, Number(text), ''];
  return [1, text.toLowerCase()];
}

export function compareClassNum(a, b) {
  const left = classNumRank(a);
  const right = classNumRank(b);
  if (left[0] !== right[0]) return left[0] - right[0];
  if (left[0] === 0 && left[1] !== right[1]) return left[1] - right[1];
  return String(left[left.length - 1]).localeCompare(String(right[right.length - 1]));
}

function blank(value) {
  return String(value ?? '').trim() === '';
}

function compareText(a, b) {
  return String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true });
}

function compareFilled(a, b, column) {
  if (column === 'class_num') return compareClassNum(a, b);
  if (DATE_COLUMNS.has(column)) {
    const left = Date.parse(String(a));
    const right = Date.parse(String(b));
    if (!Number.isNaN(left) && !Number.isNaN(right) && left !== right) return left - right;
  }
  return compareText(a, b);
}

export function compareColumn(a, b, column, direction, displayValue) {
  const left = displayValue(a, column);
  const right = displayValue(b, column);
  const leftBlank = blank(left);
  const rightBlank = blank(right);
  if (leftBlank && rightBlank) return 0;
  if (leftBlank) return 1;
  if (rightBlank) return -1;
  const cmp = compareFilled(left, right, column);
  return direction === 'desc' ? -cmp : cmp;
}

function compareDefault(a, b) {
  const lastBlankA = blank(a.last_name);
  const lastBlankB = blank(b.last_name);
  if (lastBlankA !== lastBlankB) return lastBlankA ? 1 : -1;
  const byLast = compareText(a.last_name || '', b.last_name || '');
  if (byLast) return byLast;
  const firstBlankA = blank(a.first_name);
  const firstBlankB = blank(b.first_name);
  if (firstBlankA !== firstBlankB) return firstBlankA ? 1 : -1;
  return compareText(a.first_name || '', b.first_name || '');
}

export function nextSort(current, column) {
  if (!current || current.column !== column || !current.direction) {
    return { column, direction: 'asc' };
  }
  if (current.direction === 'asc') return { column, direction: 'desc' };
  return { column: null, direction: null };
}

export function sortRows(rows, sort, displayValue) {
  const decorated = rows.map((row, index) => ({ row, index }));
  decorated.sort((left, right) => {
    const cmp = sort && sort.column && sort.direction
      ? compareColumn(left.row, right.row, sort.column, sort.direction, displayValue)
      : compareDefault(left.row, right.row);
    if (cmp) return cmp;
    return left.index - right.index;
  });
  return decorated.map((item) => item.row);
}

export function caseloadEmailText(siteEmailEnabled) {
  return siteEmailEnabled ? 'Send to therapist is on.' : 'Send to therapist is off.';
}

export function caseloadEmptyText(discipline, sessionName, siteName) {
  const what = discipline && discipline !== 'all' ? `${discipline} mandates` : 'mandates';
  return `No ${what} in ${sessionName} for ${siteName}`;
}
